import { colors } from '../../config/theme';
import React from 'react';
import Text from '../../components/text';
import Element from '../../components/element';
import Flex from '../../components/flex';
import IconWarning from '../../assets/icons/IconWarning.svg';

const TextField = props => {
  const { name, type, label, register, errors, style, ...rest } = props;
  const errMsg = errors?.[name]?.message;
  const borderBottomRed = { borderBottomColor: colors.ceriseRed };

  const displayError = _ => (
    <Flex marginTop="5px">
      <Element type="img" attrs={{ src: IconWarning }} marginRight="5px" />
      <Text family="GTAM" color={colors.ceriseRed}>
        {errMsg}
      </Text>
    </Flex>
  );

  return (
    <>
      <label htmlFor={name}>{label}</label>
      <input
        type={type || 'text'}
        style={{ ...style, ...(errMsg && borderBottomRed) }}
        id={name}
        {...register(name)}
        {...rest}
        onKeyDown={(evt) => type === 'number' && (evt.key === 'e' || evt.key === 'E') && evt.preventDefault()}
      />
      {errMsg && displayError()}
    </>
  );
};

export default TextField;
